import {
  ApiReportReportTypeChoices,
  ApiReportSectionsAiGeneratedStatusChoices,
  ReportSectionsType,
} from "@api/graphql/types-and-hooks";
import { useIsReportCompleted, useIsReviewPage } from "@components/ReportField/capabilities/flags";
import { RECOMMENDATIONS_PAGE_LOCATION, SIGNATURE_SECTION_IDENTIFIER } from "@components/ReportField/consts";
import { useAdminData } from "@providers/AdminDataProvider";
import { useReport } from "@providers/ReportProvider";

// Whether the recommendations-bank/custom-recommendation panel shows at the
// end of a recommendations section. Reproduces the legacy per-surface gating:
//   assessment  (InitialAssessment)          -> no recommendations panel
//   evaluation  (DiagnosisEvaluation + step) -> recommendations section, excluding signature
//   clinical    (Reassessment | DE + single) -> recommendations section, non-Catalight only
//     (legacy's ClinicalReportAddRecommendationsPanel mount only excludes Catalight, not AT4K)
export const useCanAddRecommendation = (section: ReportSectionsType): boolean => {
  const { report, viewMode } = useReport();
  const { isCatalightUser } = useAdminData();
  const isReviewPage = useIsReviewPage();
  const isCompleted = useIsReportCompleted();
  const sectionStillGenerating =
    section.aiGeneratedStatus === ApiReportSectionsAiGeneratedStatusChoices.SectionPredictionPending;

  if (isReviewPage || isCompleted || sectionStillGenerating) return false;

  const onRecommendations = section.pageLocation === RECOMMENDATIONS_PAGE_LOCATION;

  if (report.reportType === ApiReportReportTypeChoices.InitialAssessment) return false;

  if (report.reportType === ApiReportReportTypeChoices.DiagnosisEvaluation && viewMode === "step") {
    return onRecommendations && section.sectionIdentifier !== SIGNATURE_SECTION_IDENTIFIER;
  }

  // clinical (Reassessment | Diagnosis Evaluation single-page)
  return onRecommendations && !isCatalightUser;
};
